require("!!C:\\Users\\TEJADA\\Desktop\\PROYECTOS MGS\\imm\\V3\\front\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Users\\TEJADA\\Desktop\\PROYECTOS MGS\\imm\\V3\\front\\node_modules\\raw-loader\\index.js!C:\\Users\\TEJADA\\Desktop\\PROYECTOS MGS\\imm\\V3\\front\\node_modules\\chart.js\\dist\\Chart.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/chart.js/dist/Chart.js
// module id = 790
// module chunks = 5